import { SERVICE_GROUP_LABELS } from "./offerFormConstants";

export function offerTabLabel(language) {
  return `Text ${language.toUpperCase()}`;
}

export function offerFieldLabel(field, language) {
  const suffix = field.requiredEn && language === "en" ? " *" : "";
  return `${field.label} ${language.toUpperCase()}${suffix}`;
}

export function offerCatalogEntityLabel(row) {
  if (!row) return "";
  const n = row.name;
  return (n && (n.en || n.ru)) || String(row.id);
}

/**
 * @param {Array} servicesList
 * @param {object} [labelMap] defaults to SERVICE_GROUP_LABELS
 */
export function groupOfferServices(servicesList, labelMap = SERVICE_GROUP_LABELS) {
  const groups = {};
  for (const s of servicesList || []) {
    const t = s.type || "other";
    if (!groups[t]) {
      groups[t] = {
        type: t,
        label: labelMap[t] || t,
        items: []
      };
    }
    groups[t].items.push(s);
  }
  return Object.values(groups);
}

export function offerDomainLanguages(domains) {
  return (domains || []).map((d) => d.language).filter(Boolean);
}
